export const COUNTDOWN_PROPS = {
  ALIGNMENT: "alignment",
  TIMER_TYPE: "timerType",
  TIMER_LAYOUT: "timerLayout",
  URL: "url",
  NEW_TAB: "newTab",
  TITLE: "title",
  TEXT: "text",
  LINK_TEXT: "linkText",
  TIME: "time",
  ICON: "icon",
  BORDER_RADIUS: "borderRadius",
  COLOR_MUTE: "colorMute",
  FORMAT: "format",
  IMAGE: "image",
};

export const DESIGN_STYLES = {
  CUSTOM_COLOR: "custom-color",
  FIXED_COLOR: "fixed-color",
  SMALL_COUNTDOWN: "small-countdown",
  BACKGROUND: "background",
};

export const DESIGN_OPTIONS = {
  ARROW: [DESIGN_STYLES.SMALL_COUNTDOWN, DESIGN_STYLES.BACKGROUND],
  ICON: [DESIGN_STYLES.CUSTOM_COLOR, DESIGN_STYLES.FIXED_COLOR],
  IMAGE: [DESIGN_STYLES.BACKGROUND],
};
